import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { callGetApi } from "../api/Apicaller";
import { ClientId, Get_My_Matching_Templates_GET, Get_My_Running_Games_GET, Get_Profile } from "../api/ApiConst";
import { Get_Template_List_GET } from "../api/ApiConst";
import { NO_ERROR } from "../api/constants";
import { AccessTokenKey, AuthTokenKey, TableIdKey, TemplateIdKey, UserDetailsKey, deleteDataFromStore, getDataFromStore, setDataInStore } from "../utils/DataStore";
import Board from "./Board";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import ModalBox from "./common/Modal";
import InnerHTML from "dangerously-set-html-content";

const Dashboard = () => {
    const [showRulesModal, setShowRulesModal] = useState(false);
    const [ruleHtml, setRuleHtml] = useState("");
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [showTemplates, setShowTemplates] = useState(false);

    const [sliderDetails, setSliderDetails] = useState([1, 2, 3]);
    var settings = {
        dots: false,
        infinite: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    function NextArrow(props) {
        const { className, style, onClick } = props;
        return <img src="assets/img/game_play/right-arrow.png" className={`slick-next ${className}`} style={{ right: "0" }} onClick={onClick} />;
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props;
        return <img src="assets/img/game_play/left-arrow.png" className={`slick-prev ${className}`} style={{ left: "0" }} onClick={onClick} />;
    }

    const init = () => {
        let accessToken = getDataFromStore(AccessTokenKey);
        if (accessToken === null) {
            navigate("/unauthorized");
            return;
        }
        getProfile();
    };
    useEffect(() => {
        init();
        window.parent.postMessage("Dashboard", "*");
    }, []);

    const [templateListData, setTemplateListData] = useState([]);
    const [runningGamesData, setRunningGamesData] = useState([]);
    const [showMyRunningGamesModel, setShowMyRunningGamesModel] = useState(false);
    const [templateList, setTemplateList] = useState([]);

    const getProfile = () => {
        callGetApi(Get_Profile.replaceAll("{clientId}", ClientId), {}, (response) => {
            if (response.errorCode === NO_ERROR) {
                setDataInStore(UserDetailsKey, response.responsePacket);
                getTemplateList();
                getMyRunningGameList();
                getMyMatchingTemplateList();
            } else {
                // toast.error(response.message, { id: "avatarList" });
            }
        });
    };

    const getTemplateList = () => {
        callGetApi(Get_Template_List_GET.replaceAll("{clientId}", ClientId), {}, (response) => {
            if (response.errorCode === NO_ERROR) {
                const res = response.responsePacket;
                let _category = [];
                let finalCategories = [];
                res.map((item) => {
                    if (!_category.includes(item.category)) {
                        _category.push(item.category);
                    }
                })
                if (_category.length > 4) {
                    const slicedCategories = _category.slice(0, 4);
                    const remainingCategories = _category.slice(4, _category.length);
                    finalCategories = [...slicedCategories, remainingCategories];
                } else {
                    finalCategories = _category;
                }
                setCategories(finalCategories);
                setTemplateListData(response.responsePacket);
            } else {
                // toast.error(response.message, { id: "avatarList" });
            }
        });
    };

    const getMyRunningGameList = () => {
        callGetApi(Get_My_Running_Games_GET.replaceAll("{clientId}", ClientId), {}, (response) => {
            if (response.errorCode === NO_ERROR) {
                // TO Auto Join Table
                if (response.responsePacket.length > 0) {
                    joinBack(response.responsePacket[0].tableId);
                }
                // setRunningGamesData(response.responsePacket);
                // setShowMyRunningGamesModel(response.responsePacket.length > 0);
            } else {
                // toast.error(response.message, { id: "avatarList" });
            }
        });
    };

    const getMyMatchingTemplateList = () => {
        callGetApi(Get_My_Matching_Templates_GET.replaceAll("{clientId}", ClientId), {}, (response) => {
            if (response.errorCode === NO_ERROR) {
                if (response.responsePacket.length > 0) {
                    joinGame(response.responsePacket[0]);
                }
            } else {
                // toast.error(response.message, { id: "avatarList" });
            }
        });
    };

    const joinGame = (templateRecord) => {
        // Board > templateRecord.recordId
        deleteDataFromStore(TemplateIdKey);
        deleteDataFromStore(TableIdKey);
        setDataInStore(TemplateIdKey, templateRecord);
        navigate(`/game`);
    };
    const joinBack = (tableId) => {
        // Board > table.tableId
        deleteDataFromStore(TemplateIdKey);
        deleteDataFromStore(TableIdKey);
        setDataInStore(TableIdKey, tableId);
        navigate(`/game`);
    };
    const totalDistributionPercentage = (everyWinnerWinningPercentage) => {
        let totalDistribution = 0;
        for (let i = 0; i < everyWinnerWinningPercentage.length; i++) {
            totalDistribution += everyWinnerWinningPercentage[i];
        }
        return totalDistribution / 100.0;
    };
    const showRules = (template) => {
        if (template.boardRule === null || template.boardRule === undefined || template.boardRule === "") {
            return;
        }
        setShowRulesModal(true);
        setRuleHtml(template.boardRule);
    };

    const showTemplateList = (game, i) => {
        if (i === 4) {
            let games = [];
            game.map((item) => {
                games.push(templateListData.filter((data) => data.category === item));
                games.flat();
                setTemplateList(games);
            })
        } else {
            setTemplateList(templateListData.filter((data) => data.category === game))
        }
        setShowTemplates(true);
    }

    useEffect(() => {
        if (!showTemplates) {
            setTemplateList([]);
        }
    }, [showTemplates])


    const categoryImages = ['assets/img/asset_002/game-1.png', 'assets/img/asset_002/game-2.png', 'assets/img/asset_002/game-3.png', 'assets/img/asset_002/game-4.png', 'assets/img/asset_002/game-5.png'];

    function insertSpaceInKeyDirect(string) {
        string = string.replace(/([A-Z])/g, ' $1').trim();
        return string;
    }

    const getTemplateListView = () => {
        return (
            <>
                <div className="theme_2MainContent">
                    <div className="dashboardList ">
                        <div className="overflow-auto flex-column d-flex pt-2" style={{ flex: "1" }}>

                            {!showTemplates ? (
                                <>
                                    <div className="h-100 d-flex justify-content-center align-items-center">
                                        <h3 className="mb-0 text-center text-white fs-21">Play and Learn MF concepts</h3>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center" style={{ flex: "1" }}>
                                        <div className="row m-0 w-100 justify-content-center">
                                            {categories.length > 0 && categories.map((game, index) => (
                                                <div className="col-xl-2 col-lg-3 col-md-4 col-6" key={index}>
                                                    <div className="gameListTail" onClick={() => showTemplateList(game, index)} >
                                                        <img className="w-100" src={`assets/img/asset_002/game-${index + 1}.png`} alt={`game-${index - 1}`} />
                                                        <div className="gameListTail-content">{game}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="h-100 d-flex justify-content-center align-items-end">
                                        <h6 className="text-center text-white fs-12 fw-500">Mutual fund investments are subject to market risks, read<br />all scheme related documents carefully.</h6>
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <div className="customHeader">
                                        <span className=" position-absolute" style={{ left: "10px" }}>
                                            <img src="assets/img/backIcon.png" className="cursor-pointer" alt="back left arrow" style={{ width: "33px" }} onClick={() => setShowTemplates(false)} />{" "}
                                        </span>
                                        <span className="headerTitle">Games List</span>
                                    </div>
                                    <div className="row m-0 w-100 justify-content-center ">

                                        {templateList.map((item) => (
                                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 " key={item.recordId}>
                                                <div className="templateListCard-tails">
                                                    <div className="templateListCard">
                                                        <div className="p-3 pt-1">
                                                            <div className="d-flex align-items-center justify-content-between ">
                                                                <div className="col-6 p-0">
                                                                    <div className="text-black fs-18 fw-600 mb-2">{item.templateTitle}</div>
                                                                </div>
                                                                <div className=" col-6 p-0">
                                                                    <div className="d-flex justify-content-end align-content-center ">
                                                                        <div className="d-flex justify-content-between align-items-center fs-12" style={{ gap: "5px" }}>
                                                                            <span>
                                                                                <img src="assets/img/game_play/timerIcon.png" alt="" />
                                                                            </span>
                                                                            <span className="text-black">
                                                                                <span className="d-block">
                                                                                    <span className="mr-2">
                                                                                        {insertSpaceInKeyDirect(item.limit)}
                                                                                        {item.limit === "NoLimit" && <></>}
                                                                                    </span>
                                                                                    {item.limit === "TurnLimit" && <span>{item.limitValue} Turns</span>}
                                                                                    {item.limit === "TimeLimit" && <span>{item.limitValue / 60} Mins</span>}
                                                                                </span>
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between ">
                                                                <div className=" d-flex">
                                                                    <div className="mr-3">
                                                                        <img src="assets/img/game_play/trophyIcon.png" alt="" />
                                                                    </div>
                                                                    <div>
                                                                        <div className="text-black fs-12">Prize Points</div>
                                                                        <div className="text-blue fs-18 fw-600">
                                                                            {(item.betAmount * item.playerCount * totalDistributionPercentage(item.everyWinnerWinningPercentage)).toFixed(2)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center fs-12" style={{ gap: "5px" }}>
                                                                    <span>
                                                                        <img src="assets/img/game_play/ludoIcon.png" alt="" />
                                                                    </span>
                                                                    <span className="text-black">{item.playerCount}</span>
                                                                </div>
                                                                <div className="">
                                                                    <button className="btn bgBlue text-white fs-12 fw-800" onClick={() => joinGame(item.recordId)}>
                                                                        PLAY NOW
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            )}

                        </div>
                    </div>
                </div>
                <ModalBox show={showRulesModal} toggleModel={() => setShowRulesModal(false)} modalClass={"sliderBlockModal"}>
                    <div className="modal-content bg-purple border-none">
                        <div className="modal-body pt-0 customScroll">
                            <div className="modal-header modal-body-header custom-border-light">
                                <button type="button" className="close btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setShowRulesModal(false)}>
                                    <span className="cursor-pointer">
                                        <img src="assets/img/game_play/modal-close.png" alt="" style={{ width: 25 }} />
                                    </span>
                                </button>
                                <h5 className="modal-title text-yellow font-size-18 font-weight-500 px-2 text-center" id="exampleModalLongTitle">
                                    RULES
                                </h5>
                            </div>
                            <div
                                className="pt-4 px-2 "
                                style={{
                                    height: "370px",
                                    overflowX: "hidden",
                                    overflowY: "auto",
                                }}
                            >
                                <div
                                    className="align-items-center mb-3"
                                    style={{
                                        fontSize: "15px",
                                        color: "white",
                                    }}
                                >
                                    <InnerHTML html={ruleHtml} />
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBox>
            </>
        );
    };

    const getMyRunningGameListView = () => {
        return (
            <>
                <div className={`modal custom-modal ${showMyRunningGamesModel ? "show d-block" : ""}`} id="playersModal">
                    <div className="modal-dialog " role="document">
                        <div className="modal-content bg-purple border-none w-100 ">
                            <div className="modal-body pt-0 customScroll">
                                <div className="modal-header modal-body-header custom-border-light">
                                    <button
                                        type="button"
                                        className="close btn-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => {
                                            setShowMyRunningGamesModel(false);
                                        }}
                                    >
                                        <span className="cursor-pointer">
                                            <img src="assets/img/game_play/modal-close.png" alt="" style={{ width: 25 }} />
                                        </span>
                                    </button>
                                    <h5 className="modal-title text-yellow font-size-18 font-weight-500 px-2 text-center" id="exampleModalLongTitle">
                                        My Running Game(s)
                                    </h5>
                                </div>
                                <div className=" text-center">
                                    {runningGamesData?.map((game) => (
                                        <div className="mt-2 custom-border-bottom p-2" key={game.tableId}>
                                            <div className="m-0 slider-card">
                                                <div className="text-white mb-2">
                                                    <div className="player-div mt-2 pb-5 rounded-0 fw-600 font-size-14">
                                                        <h5 className="text-left font-size-16  mb-3">
                                                            Session ID : <span>{game.gameSessionId}</span>
                                                        </h5>
                                                        <h5 className="text-white font-size-16 text-left d-flex justify-content-between">
                                                            <div>
                                                                Entry Fee: <span className="ml-3">{game.feeAmount}</span>
                                                            </div>
                                                            <div>Waiting For Game</div>
                                                        </h5>
                                                        <hr className="my-3" />
                                                        <div className="row mb-4">
                                                            <div className="col-6 border-right">
                                                                <div className=" d-flex align-items-center">
                                                                    <div className="player-icon-div">
                                                                        <img src="assets/img/game_play/player-icon.png" alt="Player" />
                                                                    </div>
                                                                    <h4 className="text-left font-size-16 mb-0">
                                                                        <span style={{ color: "rgb(142, 128, 228)" }}>Players</span>
                                                                        <br /> {game.playingPlayers}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="" />
                                                            </div>
                                                        </div>
                                                        <div className="text-center ">
                                                            <button className="btn custom-green-btn w-100 rounded-0 join-back-btn" onClick={() => joinBack(game.tableId)}>
                                                                Join Back
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {getTemplateListView()}
            {getMyRunningGameListView()}
        </>
    );
};

export default Dashboard;
